import React, { useState } from 'react';

export default function PlatformPasswordCard({ client, onDone, onSignOut }) {
    const [password, setPassword] = useState('');
    const [confirmation, setConfirmation] = useState('');
    const [error, setError] = useState('');
    const [busy, setBusy] = useState(false);
    async function save(event) {
        event.preventDefault();
        setError('');
        if (password !== confirmation) { setError('The passwords do not match.'); return; }
        setBusy(true);
        try {
            const { data: identity, error: identityError } = await client.rpc('bl407_identity');
            if (identityError) throw identityError;
            if (!identity?.platform_role || identity.mfa_satisfied !== true) {
                throw new Error('Complete your admin authenticator before choosing a password.');
            }
            const { error: passwordError } = await client.auth.updateUser({ password });
            if (passwordError) throw passwordError;
            setPassword(''); setConfirmation('');
            await onDone();
        } catch (failure) {
            console.error('Platform password setup failed:', failure);
            setError(failure.message || 'Your password could not be saved. Please try again.');
        } finally { setBusy(false); }
    }
    return (
        <form onSubmit={save} className="rounded-lg border border-[var(--surface-border)] bg-[var(--surface-raised)] p-6 text-[var(--ink)]">
            <h1 className="mb-3 text-xl font-semibold">Choose your platform password</h1>
            <p className="mb-4 text-sm">Your invitation or recovery email and authenticator have verified your identity. Choose your own password; nobody else creates it for you.</p>
            <label className="block">New password
                <input type="password" autoComplete="new-password" minLength={8} required value={password}
                    onChange={(event) => setPassword(event.target.value)} className="my-3 w-full rounded border bg-[var(--surface-canvas)] p-3" />
            </label>
            <label className="block">Confirm password
                <input type="password" autoComplete="new-password" minLength={8} required value={confirmation}
                    onChange={(event) => setConfirmation(event.target.value)} className="my-3 w-full rounded border bg-[var(--surface-canvas)] p-3" />
            </label>
            {error && <p role="alert" className="mb-3 text-sm text-red-600">{error}</p>}
            <button type="submit" disabled={busy} className="w-full rounded bg-[#03B7C9] p-3 text-white">
                {busy ? 'Saving password...' : 'Save password and continue'}
            </button>
            <button type="button" disabled={busy} onClick={onSignOut} className="mt-4 w-full text-sm">Sign out</button>
        </form>
    );
}
